import styled from 'styled-components';

interface ContainerProps {
  bgColor?: string;
  bgHoverColor?: string;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  display: inline-block;
  background-color: ${({ bgColor }) => bgColor || '#f0f0f0'};
  padding: 8px 12px;
  border-radius: 4px;
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  transition: background-color 0.3s ease;
  color: #fff;

  &:hover {
    background-color: ${({ bgHoverColor, bgColor }) => (bgHoverColor ? (bgHoverColor === bgColor ? `${bgColor}b3` : bgHoverColor) : (bgColor ? `${bgColor}b3` : '#f0f0f0b3'))}; /* 0.7 opacity */
  }

  &:hover::after {
    display: ${({ title }) => (title ? 'block' : 'none')};
  }
`;
